<template>
    <div>
        <div v-if="!$store.state.local.bindsRealtimeList">
            <v-card-title class="px-5 white">
                <span v-if="lv" class="text-truncate">{{lvId}}{{vereinId}} / {{verein.name}}</span>
                <span v-else>Vereinsdatenblatt</span>
                <v-spacer></v-spacer>
                <v-btn v-if="$vuetify.breakpoint.smAndUp && user.permissions.spielbericht"
                       color="primary" @click="editData()" class="mt-2">
                    Daten bearbeiten</v-btn>
            </v-card-title>
            <v-card-subtitle class="px-5 pb-2 white">
                <span v-if="lv">Vereinsdatenblatt</span>
                <span v-else>Du bist nicht angemeldet oder hast keine Berchtigung zur Bearbeitung des Vereinsdatenblatts!</span>
            </v-card-subtitle>
            <div v-if="user.permissions.spielbericht || selectedVereinId" class="px-5 pb-5">
                <v-btn v-if="$vuetify.breakpoint.xsOnly" color="primary" @click="editData()">Daten bearbeiten</v-btn>
                <vereinsdatenblatt-team :vereinsdatenblatt="vereinsdatenblatt">
                </vereinsdatenblatt-team>
                <!--<vereinsdatenblatt-team :vereinsdatenblatt="vereinsdatenblatt" small="true"
                class="mt-10">
                </vereinsdatenblatt-team>-->
            </div>
            <div v-else>
                <v-btn color="secondary" class="my-5 ml-5" @click="login()">
                    <v-icon class="mr-2">mdi-login</v-icon>
                    Anmelden</v-btn>
                <v-btn color="secondary" class="ml-5"
                       @click="navigate('Ergebnisdienst')">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon>
                    Zurück zum Ergebnisdienst</v-btn>
            </div>
        </div>
        <div v-else class="text-center">
            <v-progress-circular indeterminate color="primary" class="mt-10"></v-progress-circular>
        </div>
        <vereinsdatenblatt-edit v-if="this.$route.query.action==='editVereinsdatenblatt'"
                                :currentData="vereinsdatenblatt" :selectedVereinId="selectedVereinId">
        </vereinsdatenblatt-edit>
    </div>
</template>

<script>
    import VereinsdatenblattEdit from "./vereinsdatenblattEdit";
    import {db} from "../../../services/db";
    import SpielService from "../../../services/data/spielService";
    import VereinsdatenblattTeam from "./vereinsdatenblattTeam";
    import {Vereinsdatenblatt} from "../../../services/data/vereinsdatenblatt";

    export default {
        components: {
            VereinsdatenblattTeam,
            VereinsdatenblattEdit},
        name: "vereinsdatenblatt-display",
        props: ['selectedVereinId'],
        computed: {
            user(){ return this.$store.state.user; },
            lvId(){ return this.selectedVereinId ? this.selectedVereinId.substring(0,2) : this.user.permissions.spielbericht ?
                SpielService.getLvIdFromVereinsNrLong(this.user.permissions.spielbericht) : null ; },
            lv(){ return this.lvId ?
                this.$store.state.realtime.landesverbaende[this.lvId] : null; },
            vereinId(){return this.selectedVereinId ? this.selectedVereinId.substring(2) : this.lv ?
                SpielService.getVereinsNrFromVereinsNrLong(this.user.permissions.spielbericht) : null; },
            verein(){return this.vereinId && this.lv.vereine ?
                this.lv.vereine[this.vereinId] : { name: ''} ; },
        },
        data: () => ({
            vereinsdatenblatt: null,
            unsubscribe: null,
        }),
        created(){
            if ( (this.user.permissions.spielbericht && !this.lv) || this.selectedVereinId ) {
                this.$store.state.local.bindsRealtimeList = true;
            }
            if ( this.$route.query.action === 'editVereinsdatenblatt' ) {
                window.history.back();
            }
            if (!this.selectedVereinId) this.bindLandesverband();
            this.getVereinsdatenblatt();
        },
        destroyed() {
            if ( this.unsubscribe ) { this.unsubscribe(); }
        },
        methods: {
            editData(){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'editVereinsdatenblatt';
                this.$router.push({path: p, query: q});
            },
            login(){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.login = true;
                this.$router.push({path: p, query: q});
            },
            navigate(target){
                this.$router.push({path: '/' + target});
            },
            bindLandesverband(){
                console.log ("METHOD BIND ", this.lvId, this.lv );
                if ( this.lvId && !this.lv ) {
                    console.log ("BIND IS PERFORMED");
                    this.$store.dispatch('bindRealtimeDocument', {
                        collection: 'landesverbaende',
                        docId: this.lvId,
                        storeField: 'landesverbaende.' + this.lvId,
                    });
                }
                // bind always for bundesliga
                if ( !this.$store.state.realtime.landesverbaende['1'] ) {
                    this.$store.dispatch('bindRealtimeDocument', {
                        collection: 'landesverbaende',
                        docId: '1',
                        storeField: 'landesverbaende.1',
                    });
                }
            },
            getVereinsdatenblatt(){
                console.log ("getVereinsdatenblatt");
                if ( this.selectedVereinId ) {
                    this.vereinsdatenblatt = new Vereinsdatenblatt();
                    this.unsubscribe = db.collection('vereinsdatenblaetter')
                        .doc(this.selectedVereinId)
                        .onSnapshot((doc) => {
                            if (doc.exists) {
                                this.vereinsdatenblatt.setFromDataObject(doc.data());
                                this.vereinsdatenblatt.id = doc.id;
                                this.$store.state.local.bindsRealtimeList = false;
                            } else {
                                console.log("No such document!");
                                this.$store.state.local.bindsRealtimeList = false;
                            }
                        });
                } else if ( this.user.permissions.spielbericht && !this.vereinsdatenblatt ) {
                    this.vereinsdatenblatt = new Vereinsdatenblatt();
                    this.unsubscribe = db.collection('vereinsdatenblaetter')
                        .doc(this.user.permissions.spielbericht)
                        .onSnapshot((doc) => {
                            if (doc.exists) {
                                this.vereinsdatenblatt.setFromDataObject(doc.data());
                                this.vereinsdatenblatt.id = doc.id;
                            } else {
                                console.log("No such document!");
                            }
                        });
                    /*db.collection('vereinsdatenblaetter')
                        .doc(this.user.permissions.spielbericht)
                        .get().then((doc) => {
                            if (doc.exists) {
                                this.vereinsdatenblatt = doc.data();
                                this.vereinsdatenblatt.id = doc.id;
                            } else {
                                console.log("No such document!");
                            }
                    }).catch((error) => {
                        console.log("Error getting document:", error);
                    });*/
                }
            }
        },
        watch: {
            lvId(){
                this.bindLandesverband();
            },
            verein(){
                this.getVereinsdatenblatt();
            }
        }
    }
</script>

<style scoped>

</style>